<div class="fui-sidebar-content-container">
  @if (showFilterOptions) {
    <div class="fui-sidebar-filter sticky">
      <ng-container *ngTemplateOutlet="filterContent"></ng-container>
      @if (educationData) {
        <button class="small-btn m-t-30" (click)="hideFiltersClicked.next()">
          <fa-icon icon="chevron-left"></fa-icon>
          {{ "education.hide_filters" | translate }}
        </button>
      }
    </div>
  }
  <div>
    <div [class.fui-layout-pad-content]="!showFilterOptions" class="m-y-30">
      <div class="m-b-20">
        <div class="fui-edge-content-header">
          <div class="m-b-10">
            <button (click)="goBackClicked.next()" class="fa-button m-b-10">
              <fa-icon icon="arrow-left" class="m-r-5"></fa-icon>
              {{ "general.go_back" | translate }}
            </button>
            <fui-heading level="2" fontSize="f7" [text]="title"></fui-heading>
            @if (description) {
              <div [innerHTML]="description | safe: 'html'"></div>
            }
          </div>
        </div>
      </div>
    </div>
    @if (!displayedVideos?.length) {
      <div class="fui-layout-pad-content m-y-50">
        {{ "education.no_videos_matched_filters" | translate }}
        <br />
        <br />
        <button class="btn btn-secondary btn-sm" (click)="resetFilters()">{{ "education.reset_filters" | translate }}</button>
      </div>
    }
    @if (displayedVideos?.length) {
      <div class="p-x-5">
        <ul class="list-inline grid-container even-rows wider pad-10 video-grid">
          @for (item of displayedVideos; track item) {
            <li>
              <myp-video-grid-item [video]="item"></myp-video-grid-item>
            </li>
          }
        </ul>
      </div>
      @if (totalPages) {
        <div class="d-flex justify-content-center m-b-20 m-t-100">
          <div class="d-flex align-items-center">
            <div style="width: 30px">
              @if (page != 0) {
                <button class="fa-button focus" (click)="paginate('previous')">
                  <fa-icon class="circle-icon-btn" icon="chevron-left"></fa-icon>
                  <span class="custom-sr-only">{{ "education.previous_page" | translate }}</span>
                </button>
              }
            </div>
            <small class="d-block m-x-10">
              <span class="custom-sr-only">{{ "education.show_videos_from" | translate }}</span>
              {{ page * limit }} - {{ page * limit + limit > totalVideos ? totalVideos : page * limit + limit }} of {{ totalVideos }}
            </small>
            <div style="width: 30px">
              @if (page != totalPages) {
                <button class="fa-button focus" (click)="paginate('next')">
                  <fa-icon class="circle-icon-btn" icon="chevron-right"></fa-icon>
                  <span class="custom-sr-only">{{ "education.next_page" | translate }}</span>
                </button>
              }
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>

<ng-template #filterContent>
  @if (educationData) {
    @if (appService.videoContentType.presonus) {
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="product_associated">By Product Associated</label>
        <select
          [disabled]="filters.query || !availableProducts.length"
          [class.disabled]="filters.query || !availableProducts.length"
          class="form-control custom-select-sm"
          (change)="filter()"
          [(ngModel)]="filters.product"
          id="product_associated"
        >
          <option value="any">Any</option>
          @for (prod of availableProducts; track prod) {
            <option [value]="prod.id">{{ prod.title }}</option>
          }
        </select>
      </div>
    }
    @if (appService.videoContentType.presonus) {
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="tag">By Tag</label>
        <select [disabled]="filters.query || !availableTags.length" [class.disabled]="filters.query || !availableTags.length" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.tag" id="tag">
          <option value="any">Any</option>
          @for (tag of availableTags; track tag) {
            <option [value]="tag.id">{{ tag.title }}</option>
          }
        </select>
      </div>
    }
    <div class="form-group m-r-10">
      <label class="t-12 text-muted mb-0" for="duration">Duration</label>
      <select [disabled]="filters.query || !availableDurations.length" [class.disabled]="filters.query || !availableDurations.length" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.duration" id="duration">
        <option value="any">Any</option>
        @for (dur of availableDurations; track dur) {
          <option [value]="dur.value">{{ dur.label }}</option>
        }
      </select>
    </div>
    <button class="btn btn-secondary btn-sm" (click)="resetFilters()">Clear Filters</button>
    <br />
    <br />
  }
</ng-template>

<!-- Modal template for mobile filter: Clear Filters up left in body, Done in footer right -->
<ng-template #sidebarFilterModal let-modal>
  <div class="modal-body fui-sidebar-filter-mobile">
    <ng-container *ngTemplateOutlet="filterContent"></ng-container>
  </div>
  <div class="modal-footer fui-sidebar-filter-mobile-footer">
    <button class="btn btn-primary" (click)="modal.close()">{{ "education.done" | translate }}</button>
  </div>
</ng-template>
